import PropTypes from 'prop-types';
import {
  APP_STATE_ACTION_TYPE_USE_SYS_LOCALE,
  APP_STATE_ACTION_TYPE_USER_LOCALE,
  APP_STATE_ACTION_TYPE_USE_SYS_THEME,
  APP_STATE_ACTION_TYPE_USER_THEME,
  APP_STATE_ACTION_TYPE_USER_FONT,
  APP_STATE_ACTION_TYPE_USER_FONT_SIZE,
} from '../../state/seed-states';

export const settingsSettingablesPropTypes = PropTypes.shape({
  [APP_STATE_ACTION_TYPE_USE_SYS_LOCALE]: PropTypes.bool,
  [APP_STATE_ACTION_TYPE_USER_LOCALE]: PropTypes.bool,
  [APP_STATE_ACTION_TYPE_USE_SYS_THEME]: PropTypes.bool,
  [APP_STATE_ACTION_TYPE_USER_THEME]: PropTypes.bool,
  [APP_STATE_ACTION_TYPE_USER_FONT]: PropTypes.bool,
  [APP_STATE_ACTION_TYPE_USER_FONT_SIZE]: PropTypes.bool,
});

export const defaultSettingsSettingablesPropTypes = {
  [APP_STATE_ACTION_TYPE_USE_SYS_LOCALE]: true,
  [APP_STATE_ACTION_TYPE_USER_LOCALE]: true,
  [APP_STATE_ACTION_TYPE_USE_SYS_THEME]: true,
  [APP_STATE_ACTION_TYPE_USER_THEME]: true,
  [APP_STATE_ACTION_TYPE_USER_FONT]: true,
  [APP_STATE_ACTION_TYPE_USER_FONT_SIZE]: true,
};
